import { Injectable } from '@angular/core';
import { Project, statusEnum as projectStatusEnum } from '@data/models/project.model';
import { BusinessProject, BusinessProjectStatus } from '@data/models/business-project.model';
import { Inventory, statusEnum as inventoryStatusEnum } from '@data/models/inventory.model';

@Injectable({
    providedIn: 'root'
})
export class FilterService {

    constructor() { }

    filterProjectsByStatus(
        projects: Project[],
        statusesToExclude: projectStatusEnum[] = [projectStatusEnum.UNPROVISIONED, projectStatusEnum.CLOSED]
    ): Project[] {
        // Map statuses to their string/enum representations
        const listStatus = statusesToExclude.map((exclude) => projectStatusEnum[exclude]);
        return this.filterByStatus(projects, 'status', listStatus);
    }

    filterBusinessProjectsByStatus(
        businessProjects: BusinessProject[],
        statusesToExclude: BusinessProjectStatus[] = [BusinessProjectStatus.TERMINATED]
    ): BusinessProject[] {
        return this.filterByStatus(businessProjects, 'status', statusesToExclude);
    }

    filterInventoriesByStatus(
        inventories: Inventory[],
        statusesToExclude: inventoryStatusEnum[] = [inventoryStatusEnum.UNPROVISIONED]
    ): Inventory[] {
        return this.filterByStatus(inventories, 'status', statusesToExclude);
    }

    filterEditableInventoriesByStatus(
        inventories: Array<Inventory>,
        statusesToExclude: inventoryStatusEnum[] = [inventoryStatusEnum.UNPROVISIONED]
    ): Array<Inventory> {
        return this.filterByStatus(inventories, 'status', statusesToExclude);
    }

    private filterByStatus<T, U>(
        items: T[],
        statusField: keyof T,
        statusesToExclude: U[] = []
    ): T[] {
        return items.filter(item => {
            const status = item[statusField];
            return !statusesToExclude.some(excludeStatus =>
                excludeStatus === status
            );
        });
    }

}
